// Study API. Methods are bound to the shared ApiClient instance
// via Object.assign in src/utils/api.js.
export function createStudyApi(client) {
  return {
    async getStudyCards(userDeckId) {
      const result = await this.call('/study', {
        method: 'POST',
        body: JSON.stringify({ action: 'getStudyCards', userDeckId })
      })
      return { data: result.data, error: null }
    },

    async updateStudyCard(cardId, updates) {
      const result = await this.call('/study', {
        method: 'POST',
        body: JSON.stringify({ action: 'updateStudyCard', cardId, updates })
      })
      return { error: null }
    },

    async createStudyCard(cardData) {
      const result = await this.call('/study', {
        method: 'POST',
        body: JSON.stringify({ action: 'createStudyCard', cardData })
      })
      return { error: null }
    },

    async createStudyCards(cardsData) {
      const result = await this.call('/study', {
        method: 'POST',
        body: JSON.stringify({ action: 'createStudyCards', cardsData })
      })
      return { error: null }
    },

    async saveStudySession(session) {
      try {
        const result = await this.call('/study', {
          method: 'POST',
          body: JSON.stringify({ action: 'saveStudySession', session })
        })
        return { data: result.data, error: result.error || null }
      } catch (err) {
        return { data: null, error: err.message }
      }
    },

    async resetDailyCounters(userId) {
      try {
        const result = await this.call('/study', {
          method: 'POST',
          body: JSON.stringify({ action: 'resetDailyCounters', userId })
        })
        return { data: result.data, error: result.error || null }
      } catch (err) {
        return { data: null, error: err.message }
      }
    },

    async simulateDayTransition(userId) {
      try {
        const result = await this.call('/study', {
          method: 'POST',
          body: JSON.stringify({ action: 'simulateDayTransition', userId })
        })
        return { data: result.data, error: result.error || null }
      } catch (err) {
        return { data: null, error: err.message }
      }
    }
  }
}
